
import { common } from './common/he';
import { products } from './products/he';
import { pricing } from './pricing/he';
import { solutions } from './solutions/he';

export const he = {
  ...common,
  ...products,
  ...pricing,
  ...solutions,
};
